<template>
    <figure
        v-if="variant === 'blog' || variant === 'tru'"
        class="figure"
        :class="{ stretched: data.stretched }"
    >
        <a-media
            type="screenshot"
            :link="data.file.url"
            :alt="alt"
            :enlarged-image="data.enlarge ? data.file.url : undefined"
            fit="cover"
        />
        <figcaption v-if="data.caption" class="caption">
            {{ data.caption }}
        </figcaption>
    </figure>
    <div v-else>
        <figure class="frame">
            <a-picture :link="data.file.url" :alt="alt" fit="contain" />
        </figure>
        <div v-if="data.caption" class="frame-caption">
            {{ data.caption }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import AMedia from '@core/components/media/media.vue';
import APicture from '@core/components/picture/picture.vue';
import type { BodyVariant, ImageData } from '@model/editor-js/blocks';

defineOptions({
    name: 'BlockImage',
});

const props = defineProps<{
    id?: string;
    data: ImageData;
    variant: BodyVariant;
    title?: string;
}>();

const alt = computed(() => props.data.caption || props.title || '');
</script>

<style lang="pcss" scoped>
.body-renderer .figure {
    max-width: 764px;
    margin: 24px auto;

    @media (--viewport-desktop) {
        margin: 16px auto;
    }

    &.stretched {
        max-width: 100%;
    }

    .caption {
        max-width: 80%;
        margin: 16px auto 0 auto;
        text-align: center;
        font-size: 14px;
        line-height: 24px;
        color: var(--av-fixed-light);
    }
}

.body-renderer .frame {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 352px;
    max-width: 100%;
    margin: 24px 0 16px;
    background: var(--av-solid-brand-lightest);

    :deep(img) {
        max-height: 352px;
        filter: drop-shadow(0 10px 20px rgba(36, 49, 67, 0.2));
        box-shadow: 0 10px 20px rgba(36, 49, 67, 0.2);

        @media (--viewport-mobile-wide) {
            min-height: 312px;
        }
    }
}

.body-renderer .frame-caption {
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: var(--av-fixed-lighter);
}
</style>
